import { Badge, Grid, useMediaQuery } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import TextField from "components/TextField";
import { theme } from "config/theme";
import useText from "constants/text";
import { ERequestStatus, ERequestType } from "generated/graphql";
import moment from "moment";
import React, { useMemo, useState } from "react";
import FilterCheckbox from "ui/FilterCheckbox";
import { ContainerFilter, Filter } from "../shared/MainStyles";
import { formatDate, isFieldWithValue } from "../shared/utils";

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      "& .MuiInputBase-input": {
        height: "0.1rem",
        color: "gray",
      },
    },
    badge: {
      margin: "0px 10px 0px 15px",
    },
  })
);
interface IrequestFilterProps {
  getDateFilter: (from: string, to: string) => void;
  getFilter: (filter: string, options: any[]) => void;
}

export default function RequestFilter({ getDateFilter, getFilter }: IrequestFilterProps) {
  const { text } = useText();
  const [requestDateSearchFrom, setRequestDateSearchFrom] = useState("");
  const [requestDateSearchTo, setRequestDateSearchTo] = useState("");
  const [checkedFilters, setCheckedFilters] = useState([]);
  const [checkedMissions, setCheckedMissions] = useState([]);
  const [checkedStatus, setCheckedStatus] = useState([]);
  const classes = useStyles();
  const smallScreen = useMediaQuery(theme.breakpoints.down("xs"));

  const onChangeDate = (event: React.ChangeEvent<HTMLInputElement>) => {
    switch (event.target.name) {
      case "searchDateFrom":
        setRequestDateSearchFrom(event.target.value);
        if (
          !requestDateSearchTo ||
          !event.target.value ||
          moment(event.target.value).isAfter(moment(requestDateSearchTo))
        ) {
          setRequestDateSearchTo(event.target.value);
          getDateFilter(event.target.value, event.target.value);
        } else {
          getDateFilter(event.target.value, requestDateSearchTo);
        }
        break;
      case "searchDateTo":
        setRequestDateSearchTo(event.target.value);
        if (!requestDateSearchFrom) {
          setRequestDateSearchFrom(event.target.value);
          getDateFilter(event.target.value, event.target.value);
        } else {
          getDateFilter(requestDateSearchFrom, event.target.value);
        }
        break;
      default:
        break;
    }
  };

  const filters = [
    {
      label: text.requestQuote.filter_by_mission_type,
      value: "mission",
    },
    {
      label: text.requestQuote.filter_by_request_status,
      value: "status",
    },
  ];

  const optionsFilterStatus = [
    {
      label: text.requestQuote.request_requested,
      value: ERequestStatus.Requested,
    },
    {
      label: text.requestQuote.request_accepted,
      value: ERequestStatus.Accepted,
    },
    {
      label: text.requestQuote.request_approved,
      value: ERequestStatus.Approved,
    },
    {
      label: text.requestQuote.request_declined,
      value: ERequestStatus.Declined,
    },
  ];

  const optionsFiltersMission = [
    {
      label: text.requestQuote.samapaser,
      value: ERequestType.Mad,
    },
    {
      label: text.requestQuote.national_transport,
      value: ERequestType.Nt,
    },
    {
      label: text.requestQuote.tour,
      value: ERequestType.Tr,
    },
  ];

  const filterArray = (allOptions: Array<string>, newOption: string) => {
    const selectedIndex = allOptions.findIndex((o) => o === newOption);
    let newSelected: Array<string> = [];
    if (selectedIndex === -1) {
      newSelected = allOptions.concat(newOption);
    } else if (selectedIndex >= 0) {
      newSelected = allOptions.slice(0, selectedIndex).concat(allOptions.slice(selectedIndex + 1));
    }
    return newSelected;
  };

  const getCheckedOptionFilter = (allOptions: string[], newOption: string, filterName?: string) => {
    const optionsChecked = filterArray(allOptions, newOption);
    isFieldWithValue(filterName) && getFilter(filterName, optionsChecked);
    return optionsChecked;
  };

  const filteredByDate = useMemo(() => checkedFilters.includes("date"), [checkedFilters]);

  const renderBadgeFiltersCount = (value: number) =>
    value ? <Badge badgeContent={value} color="primary" className={classes.badge} /> : "";

  return (
    <Filter>
      <Grid container spacing={2} style={{ textAlign: "center" }}>
        <Grid item xs={3}>
          <ContainerFilter>
            <FilterCheckbox
              filterLabel={text.all.filter}
              options={filters}
              backgroundColor={smallScreen ? "rgba(64, 180, 229, 0.25)" : "#f5f6f8"}
              getCheckedOption={(newOption) => {
                setCheckedFilters(getCheckedOptionFilter(checkedFilters, newOption));
              }}
            />
            {checkedFilters?.includes("mission") && (
              <FilterCheckbox
                filterLabel={
                  <>
                    {text.all.mission} {renderBadgeFiltersCount(checkedMissions?.length)}
                  </>
                }
                options={optionsFiltersMission}
                getCheckedOption={(newOption) => {
                  setCheckedMissions(getCheckedOptionFilter(checkedMissions, newOption, "mission"));
                }}
                backgroundColor="white"
                filterWithDropDownIcon
              />
            )}
            {checkedFilters?.includes("status") && (
              <FilterCheckbox
                filterLabel={
                  <>
                    {text.all.status} {renderBadgeFiltersCount(checkedStatus?.length)}
                  </>
                }
                options={optionsFilterStatus}
                getCheckedOption={(newOption) => {
                  setCheckedStatus(getCheckedOptionFilter(checkedStatus, newOption, "status"));
                }}
                backgroundColor="white"
                filterWithDropDownIcon
              />
            )}
          </ContainerFilter>
        </Grid>
        <Grid item xs={3} />
        {filteredByDate && (
          <>
            <Grid item xs={3} className={classes.root}>
              <TextField
                type="date"
                fullWidth
                label={text.all.from}
                name="searchDateFrom"
                id="searchDateFromRequest"
                value={requestDateSearchFrom}
                onChange={onChangeDate}
                InputLabelProps={{
                  shrink: true,
                }}
                inputProps={{
                  max: formatDate(),
                }}
              />
            </Grid>
            <Grid item xs={3} className={classes.root}>
              <TextField
                type="date"
                fullWidth
                label={text.all.to}
                name="searchDateTo"
                id="searchDateToRequest"
                value={requestDateSearchTo}
                onChange={onChangeDate}
                inputProps={{
                  min: isFieldWithValue(requestDateSearchFrom) && formatDate(0, requestDateSearchFrom),
                  max: formatDate(),
                }}
              />
            </Grid>
          </>
        )}
      </Grid>
    </Filter>
  );
}
